var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSendToReview(_vm.account, _vm.schoolList, _vm.schoolListHasItems))?_c('BaseFlow',{attrs:{"type":"success","icon":"ni ni-check-bold"},on:{"click":_vm.sendToReview}},[(_vm.schoolList.status === 'DRAFT')?[_vm._v(" Envoyer en approbation à Coop Zone ")]:[_vm._v("Renvoyer en approbation à Coop Zone")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }